import React, { useEffect, useState, useCallback, useRef } from 'react';
import DataModel from '../Util/DataModel';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { topMessageAtom, isAuthAtom } from '../../State';
import { useParams, useNavigate } from 'react-router-dom';
import isElectron from '../../Global';
import { useTranslation } from 'react-i18next';

import '../BrowserTop/BrowserTop.css';

export default function Feedback() {
  const textAreaRef = useRef(null);
  const [isSent, setIsSent] = useState(false);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const navigate = useNavigate(); //リダイレクト用
  const { t } = useTranslation();

  useEffect(() => {
    //参加成功のお知らせ
    // setTopMessageState({
    //   type: 'joined',
    //   message: 'Left call',
    // });
  }, []);

  const onTapSend = async () => {
    if (textAreaRef.current.value != '') {
      setIsSent(true);

      //DBに保存
      const result = await DataModel.sendFeedback(textAreaRef.current.value);

      setTopMessageState({
        type: 'joined',
        message: 'Sent successfully!',
      });
    }
  };

  return (
    <>
      <div id="feedbackWrapSetting">
        <h1>{t('setting.Feedback')}</h1>
        <h2>
          {t('setting.Please give us...')}
          <a target="_blank" href="https://faceless.ooo/contact">
            {t('setting.contact us')}
          </a>
          {t('setting.form')}
        </h2>
        {isSent == false ? (
          <>
            <textarea
              ref={textAreaRef}
              placeholder={t('setting.Type your feedback here')}></textarea>
            <div id="feedbackButtonAreaSetting">
              <div></div>
              <button id="feedbackSendButtonSetting" onClick={onTapSend}>
                {t('setting.Send')}
              </button>
            </div>
          </>
        ) : (
          <div id="feedbackThankyouSetting"> {t('setting.Thank you!')}</div>
        )}
      </div>
    </>
  );
}
